export default __webpack_public_path__ + "static/media/title.aa7358d5.png";